import { Box, useTheme } from '@mui/material';
import { Typography } from '../../../../components/Typography/Typography';
import { ReactComponent as ReportIcon } from '../../../../assets/icons/report.svg';
import TooltipComponent from '../../../../components/TooltipComponent/TooltipComponent';
import { FC, useCallback, useState } from 'react';

export const LightTotalCell: FC<{ total: number }> = ({ total }) => {
  const { colors } = useTheme();

  const [errorTooltipOpen, setErrorTooltipOpen] = useState(false);
  const handleErrorTooltipOpen = useCallback(() => {
    setErrorTooltipOpen(true);
  }, []);

  const handleErrorTooltipClose = useCallback(() => {
    setErrorTooltipOpen(false);
  }, []);

  const error =
    total > 100
      ? 'Input exceeds 100%. Please correct the data.'
      : total < 100
      ? 'Input is less than 100%. Please correct the data.'
      : '';

  return (
    <Box display={'flex'} gap={'5px'} alignItems={'center'}>
      <Typography variant='body' color={error ? colors.iconStatus.error : colors.text.main}>
        {total + '%'}
      </Typography>
      {!!error && (
        <TooltipComponent
          open={!!errorTooltipOpen}
          onOpen={handleErrorTooltipOpen}
          onClose={handleErrorTooltipClose}
          content={
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',

                gap: 1,
              }}
            >
              <Typography
                variant='body'
                color={colors.text.main}
                style={{
                  textWrap: 'wrap',
                }}
              >
                {error}
              </Typography>
            </Box>
          }
        >
          <ReportIcon
            onClick={handleErrorTooltipOpen}
            style={{
              cursor: 'pointer',
            }}
          />
        </TooltipComponent>
      )}
    </Box>
  );
};
